import { render, staticRenderFns } from "./Customerdepositprint.vue?vue&type=template&id=fb4a44e2&"
import script from "./Customerdepositprint.vue?vue&type=script&lang=js&"
export * from "./Customerdepositprint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports